import React, { useState } from "react";
import { Input } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

const PasswordInput = ({
  placeholder = "Enter your password",
  size = "large",
  ...props
}) => {
  const [visible, setVisible] = useState(false);

  const passwordIconStyles = { cursor: "pointer", color: "#999" };

  return (
    <Input
      {...props}
      placeholder={placeholder}
      size={size}
      type={visible ? "text" : "password"}
      allowClear
      suffix={
        visible ? (
          <EyeOutlined
            onClick={() => setVisible(false)}
            style={passwordIconStyles}
          />
        ) : (
          <EyeInvisibleOutlined
            onClick={() => setVisible(true)}
            style={passwordIconStyles}
          />
        )
      }
    />
  );
};

export default PasswordInput;
